import React from "react";
import { Star } from "lucide-react";
import "./style.css";

const Testimonials = () => {
	const testimonials = [
		{
			name: "Mobi Dixon",
			role: "Music Artist",
			content:
				"Big Cat Graphics transformed my visual identity. Their creativity and attention to detail brought my artistic vision to life in ways I never imagined possible.",
			rating: 5
		},
		{
			name: "Sarah Johnson",
			role: "Marketing Director, Standard Bank",
			content:
				"Working with Big Cat Graphics has been exceptional. They delivered stunning visuals that perfectly captured our brand essence and exceeded all expectations.",
			rating: 5
		},
		{
			name: "Ntsiki Mazwai",
			role: "Artist & Activist",
			content:
				"The team at Big Cat Graphics understands the power of visual storytelling. They created compelling artwork that resonated deeply with my audience.",
			rating: 5
		}
	];

	return (
		<section className="testimonials-section">
			<div className="testimonials-container">
				<div className="testimonials-header">
					<h2 className="testimonials-title">What Our Clients Say</h2>
					<p className="testimonials-subtitle">
						Trusted by artists and brands worldwide
					</p>
				</div>

				<div className="testimonials-grid">
					{testimonials.map((item, index) => (
						<div key={index} className="testimonial-card">
							<div className="testimonial-stars">
								{[...Array(item.rating)].map((_, i) => (
									<Star key={i} className="star-icon" />
								))}
							</div>

							<p className="testimonial-content">"{item.content}"</p>

							<div className="testimonial-footer">
								<p className="testimonial-name">{item.name}</p>
								<p className="testimonial-role">{item.role}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Testimonials;
